const Search = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_958_1654)">
        <circle cx="7.66634" cy="7.66659" r="6.33333" stroke="#272A2F" />
        <path d="M12.333 12.3333L14.6663 14.6666" stroke="#272A2F" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_958_1654">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Search
